export enum TABLENAMES {
  EMPLOYEE_FILE = "employee_file",
}

export const SCD_LOG_FORM_ID = "SCD Log";

export const ALLOWED_FILE_MIMETYPES = [
  ".png",
  ".jpg",
  ".jpeg",
  ".pdf",
  ".xls",
  ".xlsx",
  ".doc",
  ".docx",
];

export const MAX_FILE_SIZE_MB = 10; // IN MB
export const MAX_FILE_SIZE_KB = MAX_FILE_SIZE_MB * 1024; // 10 MB in KB
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 10 MB in bytes

export const MAX_FILES_UPLOAD = 10;

export enum ROLES {
  OWNER = "OWNER",
  PROGRAM_MANAGER = "PROGRAM MANAGER",
  SUPERVISOR = "SUPERVISOR",
  SC = "SC",
  SUPER_ADMIN = "SUPER ADMIN",
  DEVELOPER = "DEVELOPER",
  ADMIN = "ADMIN",
  ASSESSOR = "ASSESSOR",
  SCRUM_MASTER = "SCRUM MASTER",
}

export const ROLE_PRIORITY: Record<string, number> = {
  [ROLES.PROGRAM_MANAGER]: 3,
  [ROLES.SUPERVISOR]: 2,
  [ROLES.SC]: 1,
  [ROLES.OWNER]: 4,
  [ROLES.SUPER_ADMIN]: 9,
  [ROLES.ADMIN]: 5,
  [ROLES.DEVELOPER]: 6,
  [ROLES.ASSESSOR]: 7,
  [ROLES.SCRUM_MASTER]: 8,
};

export enum TEAM_LIMIT {
  PROGRAM_MANAGER = 1,
  SUPERVISOR = 2,
  SC = 16,
}

export enum CHANNEL_TYPE {
  COMPANY = "COMPANY",
  TEAM = "TEAM",
  CUSTOM = "CUSTOM",
}

export enum MessageType {
  SYSTEM = "SYSTEM",
  USER = "USER",
  CHANNEL_EVENT = "CHANNEL_EVENT",
}

export enum CIRStatus {
  SUBMITTED = "SUBMITTED",
  REVIEWED = "REVIEWED",
  CLOSED = "CLOSED",
}

export enum ROLE_IDS {
  ADMIN = 5,
  OWNER = 4,
  PROGRAM_MANAGER = 3,
  SUPERVISOR = 2,
  SC = 1,
}

export const MAX_LENGTH_DESCRIPTION_SHOW = 30;

export enum CALENDAR_VIEW {
  day = "day",
  week = "week",
  month = "month",
}

export enum TaskType {
  Recurring = "Recurring",
  Interim = "Interim",
}

export const CHAT_PAGE_SIZE = 50;

export enum EXTERNAL_FILE_REQUEST_STATUS {
  PENDING = "PENDING",
  UPLOADED = "UPLOADED",
  REVOKED = "REVOKED",
  EXPIRED = "EXPIRED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
}

export enum PAGINATION {
  PageNumber = 1,
  PageSize = 10,
}

export const LOBBY_TIMEOUT_MINUTES = 15; // In min

export const DefaultUSCountryCodeId = 2;

export enum ParticipantResourceStatus {
  Accepting = "Accepting",
  WaitlistOnly = "WaitlistOnly",
  NotAccepting = "NotAccepting",
}

export const ParticipantResourceStatusOptions = [
  { value: ParticipantResourceStatus.Accepting, label: "Accepting" },
  { value: ParticipantResourceStatus.WaitlistOnly, label: "Waitlist Only" },
  { value: ParticipantResourceStatus.NotAccepting, label: "Not Accepting" },
];

export const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export const NOTIFICATION_TIME_OPTIONS = [
  { label: "5 Minutes", value: 5 },
  { label: "15 Minutes", value: 15 },
  { label: "1 Hour", value: 60 },
];

export const timeZones = [
  { label: "Asia/Kolkata (IST)", value: "Asia/Kolkata" },
  { label: "America/Chicago (CST)", value: "America/Chicago" },
  { label: "America/New_York (EST)", value: "America/New_York" },
  { label: "America/Los_Angeles (PST)", value: "America/Los_Angeles" },
  { label: "Europe/London (GMT)", value: "Europe/London" },
  { label: "Asia/Dubai (GST)", value: "Asia/Dubai" },
  { label: "Asia/Singapore (SGT)", value: "Asia/Singapore" },
  { label: "Australia/Sydney (AEST)", value: "Australia/Sydney" },
];

export enum OwnerGraphTrend {
  Participants = "Participants",
  Task = "Task",
  Billing = "Billing",
}

export enum SignatureMappingStatus {
    pending,
    completed,
    rejected,
    canceled
}

export enum BillingInterval {
    MONTHLY = "MONTHLY",
    QUATERLY = "QUATERLY",
    ANNUAL = "ANNUAL",
}

export enum SubscriptionStatus {
    TRIAL_ACTIVE = "TRIAL_ACTIVE",
    ACTIVE = "ACTIVE",
    READ_ONLY_TRIAL_EXPIRED = "READ_ONLY_TRIAL_EXPIRED",
    READ_ONLY_DELINQUENT = "READ_ONLY_DELINQUENT",
    SUSPENDED = "SUSPENDED"
}

export enum DiscountType {
  NONE = "NONE",
  PERCENT = "PERCENT",
  FIXED = "FIXED"
}


export enum DiscountDurationType {
    ONE_TIME =  "ONE_TIME",
    RECURRING_UNTIL_CANCELLED  = "RECURRING_UNTIL_CANCELLED",
    RECURRING_UNTIL_DATE = "RECURRING_UNTIL_DATE"
}


export enum PaymentMethodType {
    NONE = "NONE",
    ACH = "ACH",
    CARD = "CARD"
}

export enum PlanFeatureKey {
  CHAT = "chat",
  VIDEO_CALL = "video_call",
  SIGN_DOCUMENT = "sign_document",
}

export enum HelcimPaymentStatus {
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  INTERNAL_DEDUCTION = "INTERNAL_DEDUCTION",
  REFUNDED = "REFUNDED",
  VOIDED = "VOIDED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED"
}